import { render } from "./LeagueOdds.vue?vue&type=template&id=a6742180&scoped=true"
import script from "./LeagueOdds.vue?vue&type=script&lang=js"
export * from "./LeagueOdds.vue?vue&type=script&lang=js"

import "./LeagueOdds.vue?vue&type=style&index=0&id=a6742180&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6742180"]])

export default __exports__